import { ref } from 'vue'
import { createReminder, getAllReminders, deleteReminder, getNotifications } from '../../../services/reminder'
export const useReminder = () => {
  const isLoading = ref(false)
  const reminders = ref([])

  return {
    isLoading,
    reminders,
    async add(reminderData: any) {
      isLoading.value = true
      try {
        await createReminder(reminderData)
        const { data } = await getAllReminders()
        reminders.value = data
      } catch (e) {
        throw e
      } finally {
        isLoading.value = false
      }
    },
    async fetch() {
      isLoading.value = true
      try {
        const { data } = await getAllReminders()
        reminders.value = data
      } catch (e) {
        throw e
      } finally {
        isLoading.value = false
      }
    },
    async delete(reminderId: number) {
      isLoading.value = true
      try {
        await deleteReminder(reminderId)
        const { data } = await getAllReminders()
        reminders.value = data
      } catch (e) {
        throw e
      } finally {
        isLoading.value = false
      }
    },

    async getAllNotifications() {
      isLoading.value = true
      try {
        const { data } = await getNotifications()
        return data
      } catch (e) {
        throw e
      } finally {
        isLoading.value = false
      }
    },
  }
}
